import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <img 
              src="/images/세무회계 결 ver 1.png" 
              alt="세무회계 결" 
              className="logo-image"
            />
          </Link>
        </div>
        
        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <ul>
            <li>
              <Link 
                to="/" 
                className={location.pathname === '/' ? 'active' : ''}
                onClick={closeMenu}
              >
                홈
              </Link>
            </li>
            <li className="desktop-only">
              <Link 
                to="/about" 
                className={location.pathname === '/about' ? 'active' : ''}
                onClick={closeMenu}
              >
                회사소개
              </Link>
            </li>
            <li className="desktop-only">
              <Link 
                to="/services" 
                className={location.pathname === '/services' ? 'active' : ''}
                onClick={closeMenu}
              >
                업무소개
              </Link>
            </li>
            <li className="desktop-only">
              <Link 
                to="/correction" 
                className={location.pathname === '/correction' ? 'active' : ''}
                onClick={closeMenu}
              >
                경정청구
              </Link>
            </li>
            <li className="desktop-only">
              <Link 
                to="/contact" 
                className={location.pathname === '/contact' ? 'active' : ''}
                onClick={closeMenu}
              >
                상담문의
              </Link>
            </li>
          </ul>
        </nav>

        <button 
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label="메뉴 열기/닫기"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
